import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import usageTrackingService from '../services/usage/usageTrackingService';
import { trackPageView } from '../utils/metaPixel';

const PAGE_NAMES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/patients': 'Pacientes',
  '/patients/chart': 'Ficha do paciente',
  '/patient-dashboard': 'Dashboard do Paciente',
  '/appointments': 'Agendamentos',
  '/professionals': 'Profissionais',
  '/laboratory': 'Laboratório',
  '/pharmacy': 'Farmácia',
  '/financial': 'Financeiro',
  '/financial/transactions': 'Transações Financeiras',
  '/financial/receivables': 'Contas a Receber',
  '/financial/payments': 'Pagamentos',
  '/financial/reports': 'Relatórios Financeiros',
  '/financial/reconciliation': 'Conciliação Bancária',
  '/financial/operational': 'Dashboard Operacional',
  '/financial/analytics': 'Analytics Financeiro',
  '/reports': 'Relatórios',
  '/settings': 'Configurações',
  '/telemedicine': 'Telemedicina',
  '/therapeutic-attendance': 'Atendimento Terapêutico',
  '/reminders': 'Lembretes',
  '/ehr': 'Prontuário Eletrônico',
  '/dynamic-ehr': 'Prontuário Dinâmico',
  '/patient-ai': 'IA Médica',
  '/analise-clinica': 'Análise Clínica',
  '/integrated-medical-ai': 'IA Médica Integrada',
  '/ai-analysis': 'Análise de IA',
  '/omnichannel': 'Omnichannel',
  '/omnichannel/dashboard': 'Dashboard Omnichannel',
  '/omnichannel/channels': 'Canais',
  '/omnichannel/contacts': 'Contatos',
  '/omnichannel/chatbots': 'Chatbots',
  '/omnichannel/automation': 'Automação',
  '/omnichannel/marketing': 'Marketing',
  '/omnichannel/reports': 'Relatórios Omnichannel',
  '/omnichannel/analytics': 'Analytics Omnichannel',
  '/crm': 'CRM',
  '/crm/automations': 'Automações CRM',
  '/crm/leads': 'Leads',
  '/crm/funnel': 'Funil de Vendas',
  '/inventory': 'Estoque',
  '/user-management': 'Gestão de Usuários',
  '/advanced-reports': 'Relatórios Avançados',
  '/admin-usage-analytics': 'Monitoramento Admin',
};

export const usePageTracking = () => {
  const location = useLocation();
  const { currentUser } = useAuthContext();
  // index.html already fires the initial PageView; only track SPA navigations after that
  const isFirstMetaPageView = useRef(true);

  useEffect(() => {
    if (isFirstMetaPageView.current) {
      isFirstMetaPageView.current = false;
    } else {
      trackPageView();
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (currentUser) {
      const pageName = PAGE_NAMES[location.pathname] || 
                      location.pathname.split('/').filter(Boolean).join(' / ') || 
                      'Página Inicial';
      usageTrackingService.logPageView(pageName, location.pathname, currentUser.uid);
    }
  }, [location.pathname, currentUser]);
};

